export interface GlobalExclusionsAppWebComponentSchema {
  userLists: Array<ExclusionListItem>;
  companyLists: Array<ExclusionListItem>;
  activeExclusionList?: ExclusionListItem;
}

export enum RpcExclusionListsMethod {
  GET_LIST_INFO = "getListInfo",
  GET_COMPANY_LISTS = "getDefaultExclusionLists",
  GET_CURRENT_USER_LISTS = "getCurrentUserLists",
}

export enum RpcAction {
  EXCLUSION_LISTS = "ExclusionLists",
}

export interface ExclusionListItem {
  label: string;
  value: string;
}
